import React, { useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link } from "react-router-dom";
import { postData } from "../../api/api";
import { FieldError } from "../../Components/FieldError/FieldError";
import { useNotification } from "../../Notification/Notification";
const registerSchema = yup.object({
  email: yup
    .string()
    .trim()
    .email("Invalid email address")
    .required("Email is required"),
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters"),
  phoneNumber: yup
    .string()
    .required("Phone number is required")
    .matches(/^[0-9]+$/, "Phone number can only contain numbers"),
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  dateOfBirth: yup
    .date()
    .required("Date of birth is required")
    .nullable("Date of birth is required")
    .typeError("Date of birth is required"),
  gender: yup.string().required("Gender is required"),
});


const RegisterRequestDefault = {
  email: "",
  password: "",
  phoneNumber: "",
  firstName: "",
  lastName: "",
  dateOfBirth: "",
  gender: "",
};

const Register = () => {
  const methods = useForm({
    resolver: yupResolver(registerSchema),
    defaultValues: RegisterRequestDefault,
  });
  const [disabled, setDisabled] = useState(false);
  const [LoginState, setLogin] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [LoginError, setLoginError] = useState(false);
  const { notificationApi } = useNotification();
  const {
    handleSubmit,
    register,
    setFocus,
    reset,
    formState: { errors },
  } = methods;

  const onSubmit = (data) => {
    setDisabled(true);
    setLogin(false);
    console.log("Form data: ", data);
    postData("/accounts", {
      ...data,
      roleId: "12555e1b-14b2-46c9-b49b-cf1835a17204",
    })
      .then((e) => {
        console.log(e);
        notificationApi(
          "success",
          "Register success",
          `Please confirm your account at gmail:  ${data.email}`
        );
        setLogin(true);
        setErrorMessage(true);
        setDisabled(false);
      })
      .catch((error) => {
        setErrorMessage(true);
        setDisabled(false);
        setErrorMessage(error?.data?.message);
        setLogin(true);
        console.log(error);
      });
  };

  useEffect(() => {
    setFocus("firstName");
  }, [setFocus]);

  return (
    <div
      className="flex items-center justify-center w-screen bg-cover bg-center pt-4 pb-6"
      style={{
        backgroundImage: `url(https://i0.wp.com/plumvillage.org/wp-content/uploads/2024/10/6A2A8913.jpg?ssl=1)`,
      }}
    >
      <div className="min-h-screen w-[600px] bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Create your account
          </h2>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <FormProvider {...methods}>
              <form className="space-y-6" onSubmit={handleSubmit(onSubmit)}>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    First Name
                  </label>
                  <input
                    {...register("firstName")}
                    type="text"
                    className={`appearance-none block w-full px-3 py-2 border ${
                      errors.firstName ? "border-red-500" : "border-gray-300"
                    } rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm`}
                  />
                  {errors.firstName && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.firstName.message}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Last Name
                  </label>
                  <input
                    {...register("lastName")}
                    type="text"
                    className={`appearance-none block w-full px-3 py-2 border ${
                      errors.lastName ? "border-red-500" : "border-gray-300"
                    } rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm`}
                  />
                  {errors.lastName && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.lastName.message}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Email address
                  </label>
                  <input
                    {...register("email")}
                    type="text"
                    className={`appearance-none block w-full px-3 py-2 border ${
                      errors.email ? "border-red-500" : "border-gray-300"
                    } rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm`}
                  />
                  {errors.email && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.email.message}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Password
                  </label>
                  <input
                    {...register("password")}
                    type="password"
                    className={`appearance-none block w-full px-3 py-2 border ${
                      errors.password ? "border-red-500" : "border-gray-300"
                    } rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm`}
                  />
                  {errors.password && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.password.message}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Phone Number
                  </label>
                  <input
                    {...register("phoneNumber")}
                    type="text"
                    className={`appearance-none block w-full px-3 py-2 border ${
                      errors.phoneNumber ? "border-red-500" : "border-gray-300"
                    } rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm`}
                  />
                  {errors.phoneNumber && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.phoneNumber.message}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Date of Birth
                  </label>
                  <input
                    {...register("dateOfBirth")}
                    type="date"
                    className={`appearance-none block w-full px-3 py-2 border ${
                      errors.dateOfBirth ? "border-red-500" : "border-gray-300"
                    } rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm`}
                  />
                  {errors.dateOfBirth && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.dateOfBirth.message}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Gender
                  </label>
                  <select
                    {...register("gender")}
                    className={`block w-full px-3 py-2 border ${
                      errors.gender ? "border-red-500" : "border-gray-300"
                    } rounded-md shadow-sm focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm`}
                  >
                    <option value="">Select your gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    {/* <option value="Other">Other</option> */}
                  </select>
                  {errors.gender && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.gender.message}
                    </p>
                  )}
                </div>

                {/* <div className="flex items-center">
                  <input
                    {...register("terms", { required: true })}
                    type="checkbox"
                    className="h-4 w-4 text-yellow-600 focus:ring-yellow-500 border-gray-300 rounded"
                  />
                  <label className="ml-2 block text-sm text-gray-900">
                    I agree to the{" "}
                    <a
                      href="#"
                      className="text-yellow-600 hover:text-yellow-500"
                    >
                      Terms and Conditions
                    </a>
                  </label>
                  {errors.terms && (
                    <p className="text-red-500 text-sm mt-1">
                      You must agree to the terms
                    </p>
                  )}
                </div> */}
                <FieldError className="text-red-500 text-center">
                  {LoginState || LoginError ? errorMessage : ""}
                </FieldError>
                <div>
                  <button
                    type="submit"
                    className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
                      disabled
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
                    }`}
                    disabled={disabled} // Vô hiệu hóa nút khi đang loading
                  >
                    {disabled ? "Processing..." : "Register"}
                  </button>
                </div>
              </form>
            </FormProvider>
          </div>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md text-center">
          <p className="text-sm text-gray-600">
            Already have an account?{" "}
            <Link
              to="/login"
              className="font-medium text-yellow-600 hover:text-yellow-500"
            >
              Sign in here
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
